// extracted by mini-css-extract-plugin
export default {"sideBar":"Sidebar_sideBar__Ylbpw","monument":"Sidebar_monument__uOGWi","textBlock":"Sidebar_textBlock__iW9Rj"};